import cleanedFilename from '~/util/cleanedFilename';

export default {
  OPERATOR_DROPDOWN: `${cleanedFilename(__filename)}-operator-dropdown`,
};
